import type { Core } from '@pdftron/webviewer';
import { roundDecimals } from './mathUtils';

export const CSSBlack = '#000000';
export const CSSWhite = '#FFFFFF';

/**
 * red: #FF0000, green: #00FF00, blue: #0000FF
 */
export function toCSSColor(color: number | null): string {
    if (color === null) {
        return 'transparent';
    }
    return '#' + (color & 0xffffff).toString(16).padStart(6, '0');
}

/**
 * Removes the transparency information from color.
 * 0xFF123456 would be 0x123456.
 */
export function removeTransparency(color: number): number {
    return color & 0xffffff;
}

// // /**
// //  * Adds the transparency information from color.
// //  * 0x??123456 would be 0xFF123456.
// //  */
// // export function addTransparency(color: number): number {
// //     return color | 0xff000000;
// // }

/**
 * Apryse Color to int
 */
export function intColor(color: Core.Annotations.Color): number {
    if (!color) {
        return -1;
    }
    return numberFromHex(color.toHexString());
}

export function numberFromHex(hexString: string | null): number {
    if (!hexString) {
        return 0;
    }
    return parseInt(hexString.replace('#', ''), 16);
}

// function hexFromRGB(rgbString: string): string {
//     const step1 = rgbString.replace('rgb', '');
//     const step2 = step1.replace('(', '');
//     const cleaned = step2.replace(')', '');

//     const rgbNumbers = cleaned.split(',').map(s => parseInt(s));
//     const hexStrings = rgbNumbers.map(n => n.toString(16).padStart(2, '0'));

//     return '#' + hexStrings.join('');
// }

// export function toPDFColor(cssColor: string): number {
//     if (cssColor.startsWith('#')) {
//         return numberFromHex(cssColor);
//     }
//     if (cssColor.startsWith('rgb')) {
//         return numberFromHex(hexFromRGB(cssColor));
//     }
//     return 0;
// }

/**
 * Determines if a given color integer has a brightness of more than 50%
 * @param color - Color to analyse.
 * @returns True if the color has >= 50% brightness; otherwise false.
 */
export function isLightColor(color: number): boolean {
    // Get the color's RBG values
    const r = (color & 0xff0000) >> 16;
    const g = (color & 0xff00) >> 8;
    const b = color & 0xff;

    // Calculate luminance (0 = white, 1 = black)
    const lum = (r * 0.299 + g * 0.587 + b * 0.114) / 256;

    return lum >= 0.5;
}

export function toCompareColor(color: number) {
    // Get the color's RBG values
    const r = (color & 0xff0000) >> 16;
    const g = (color & 0xff00) >> 8;
    const b = color & 0xff;

    return {
        A: 255,
        R: r,
        G: g,
        B: b,
    };
}

export function usernameToColor(userName: string | undefined): string {
    if (!userName) {
        userName = '';
    }

    let hash = 0;

    for (let i = 0; i < userName.length; i += 1) {
        hash = userName.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

/**
 * example #00FF00 => { r: 0, g: 255, b: 0 }
 */
export function hexToRGB(hex: string): { r: number; g: number; b: number } {
    const { style } = new Option();
    style.color = hex;

    // example: 'rgb(0, 255, 0)'
    const rgbString = style.color;

    const colorNumbers = rgbString
        .substring(rgbString.indexOf('(') + 1, rgbString.indexOf(')'))
        .split(',')
        .map(x => Number(x.trim()));

    return {
        r: colorNumbers[0],
        g: colorNumbers[1],
        b: colorNumbers[2],
    };
}

/**
 * examples: 0 => 0; 127 => 0.498; 128 => 0.502; 255 => 1
 */
export function rgColor(color: number): number {
    return roundDecimals(color / 255, 3);
}
